import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { validationSchema } from "./validationSchema";
import { toast } from "react-toastify";
import useList from "../../controller/list-controller";
import PageHeader from "../../components/table/pageHeader/PageHeader";
import FormInput from "../../components/form/FormInput";
import FormSelect from "../../components/form/FormSelect";
import FmiCases from "../../assets/sidebar/fmiCases";
import Button from "../../components/buttton/button";
import { useNavigate } from "react-router-dom";
import FormTextarea from "../../components/form/FormTextarea";
import { getCookie } from "../../utils/session";
import useLead from "../../controller/lead-controller";

const FmiLeadsCreate = () => {
  const fsoId = getCookie("fsoId");
  const navigate = useNavigate();
  const { allConst, getConstants, isLoading, errMsg } = useList();
  const {
    succMsg,
    errMsg: errMsg2,
    isLoading: isLoading2,
    createLead,
  } = useLead();
  const [isLoader, setIsLoader] = useState(true);
  const formik = useFormik({
    initialValues: {
      name: "",
      companyName: "",
      email: "",
      phone: "",
      leadType: "",
      industry: "",
      street: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
      description: "",
      status: "",
      leadSourcce: "",
    },
    validationSchema,
    enableReinitialize: false,
    onSubmit: async (values) => {
      createLead({
        ...values,
      });
    },
  });

  useEffect(() => {
    getConstants({
      accountId: "",
      fsoId,
      objectName: "Lead",
    });
  }, []);

  useEffect(() => {
    setIsLoader(isLoading || isLoading2);
  }, [isLoading, isLoading2]);

  useEffect(() => {
    if (succMsg) {
      toast.success(succMsg);
      formik.resetForm();
      navigate(`/fmi-leads`);
    }
  }, [succMsg]);

  useEffect(() => {
    if (errMsg || errMsg2) {
      toast.error(errMsg || errMsg2);
    }
  }, [errMsg, errMsg2]);

  useEffect(() => {
    if (allConst) {
      formik.setFieldValue("status", allConst?.status);
      formik.setFieldValue("leadType", allConst?.leadType);
      formik.setFieldValue("leadSourcce", allConst?.leadSourcce);
    }
  }, [allConst]);

  return (
    <div className="flex flex-col h-full justify-end align-end">
      <PageHeader
        svg={<FmiCases color="white" width="24" height="24" />}
        text="New Lead"
        subTitle="Add Lead"
        isBackBtn={true}
        onBackClick={() => navigate("/fmi-leads")}
      />
      <div className="order-create-container md:p-4 md:rounded-lg h-full overflow-x-hidden overflow-y-auto">
        <form
          id="createCaseForm"
          className="h-full"
          onSubmit={formik.handleSubmit}
        >
          <div className="">
            <div className="title font-semibold text-base	md:rounded-lg py-3.5 px-4">
              Information
            </div>
            <div className="md:py-6 pt-2 grid md:grid-cols-2 md:gap-y-6 p-4">
              <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                <div className="fieldName font-normal text-sm flex items-center text-lg md:mb-0 mb-2">
                  Name<span className="asterisk-label ml-1">*</span>
                </div>
                <div className="md:ml-8 col-span-2">
                  <FormInput
                    dom={{
                      name: "name",
                      type: "text",
                      className: "p-2.5",
                      value: formik?.values?.name,
                      onChange: formik?.handleChange,
                      onBlur: formik?.handleBlur,
                    }}
                    fullwidth={true}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    errorMessage={formik.errors.name}
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-3 md:ml-4 md:mb-0 mb-4">
                <div className="fieldName font-normal text-sm flex items-center text-lg md:mb-0 mb-2">
                  Status
                </div>
                <div className="md:ml-8 col-span-2 pr-0.5">
                  <FormInput
                    dom={{
                      name: "status",
                      type: "text",
                      className: "p-2.5",
                      value: formik?.values?.status,
                      disabled: true,
                    }}
                    fullwidth={true}
                    error={
                      formik.touched.status && Boolean(formik.errors.status)
                    }
                    errorMessage={formik.errors.status}
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                <div className="fieldName font-normal text-sm flex items-center text-lg md:mb-0 mb-2">
                  Company<span className="asterisk-label ml-1">*</span>
                </div>
                <div className="md:ml-8 col-span-2">
                  <FormInput
                    dom={{
                      type: "text",
                      name: "companyName",
                      className: "p-2.5",
                      value: formik?.values?.companyName,
                      onChange: formik?.handleChange,
                      onBlur: formik?.handleBlur,
                    }}
                    className={"py-0 "}
                    fullwidth={true}
                    error={
                      formik.touched.companyName &&
                      Boolean(formik.errors.companyName)
                    }
                    errorMessage={
                      formik.touched.companyName && formik.errors.companyName
                    }
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-3 md:ml-4 md:mb-0 mb-4">
                <div className="fieldName font-normal text-sm flex items-center text-lg md:mb-0 mb-2">
                  Email<span className="asterisk-label ml-1">*</span>
                </div>
                <div className="md:ml-8 col-span-2">
                  <FormInput
                    dom={{
                      type: "email",
                      name: "email",
                      className: "p-2.5",
                      value: formik?.values?.email,
                      onChange: formik?.handleChange,
                      onBlur: formik?.handleBlur,
                    }}
                    className={"py-0 "}
                    fullwidth={true}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    errorMessage={formik.touched.email && formik.errors.email}
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                <div className="fieldName font-normal text-sm flex items-center text-lg md:mb-0 mb-2">
                  Lead Type<span className="asterisk-label ml-1">*</span>
                </div>
                <div className="md:ml-8 col-span-2 pr-0.5">
                  <FormInput
                    dom={{
                      name: "leadType",
                      type: "text",
                      className: "p-2.5",
                      value: formik?.values?.leadType,
                      disabled: true,
                    }}
                    fullwidth={true}
                    error={
                      formik.touched.leadType && Boolean(formik.errors.leadType)
                    }
                    errorMessage={formik.touched.email && formik.errors.email}
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-3 md:ml-4 md:mb-0 mb-4">
                <div className="fieldName font-normal text-sm flex items-center text-lg md:mb-0 mb-2">
                  Phone<span className="asterisk-label ml-1">*</span>
                </div>
                <div className="md:ml-8 col-span-2">
                  <FormInput
                    dom={{
                      type: "phone",
                      name: "phone",
                      className: "p-2.5",
                      value: formik?.values?.phone,
                      onChange: formik?.handleChange,
                      onBlur: formik?.handleBlur,
                    }}
                    className={"py-0 "}
                    fullwidth={true}
                    error={formik.touched.phone && Boolean(formik.errors.phone)}
                    errorMessage={formik.touched.phone && formik.errors.phone}
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-3 md:mr-4">
                <div className="fieldName font-normal text-sm flex items-center text-lg md:mb-0 mb-2">
                  Industry<span className="asterisk-label ml-1">*</span>
                </div>
                <div className="md:ml-8 col-span-2 pr-0.5">
                  <FormSelect
                    name="industry"
                    className={"py-0"}
                    fullwidth={true}
                    options={allConst?.industry?.map((dt) => ({
                      label: dt,
                      value: dt,
                    }))}
                    value={{
                      label: formik?.values?.industry,
                      value: formik?.values?.industry,
                    }}
                    onChange={(e) => {
                      if (e) formik.setFieldValue("industry", e?.value, true);
                    }}
                    error={
                      formik.touched.industry && Boolean(formik.errors.industry)
                    }
                    errorMessage={
                      formik.touched.industry && formik.errors.industry
                    }
                    isClearable={false}
                    isSearchable={false}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="title font-semibold text-base	md:rounded-lg py-3.5 px-4">
                Address Information
              </div>
              <div className="md:py-6 pt-4 px-4">
                <div className="grid md:grid-cols-2 md:rounded-b-lg md:py-3">
                  <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Street
                    </div>
                    <div className="md:ml-8 col-span-2">
                      <FormInput
                        dom={{
                          type: "text",
                          name: "street",
                          className: "p-2.5",
                          value: formik?.values?.street,
                          onChange: formik?.handleChange,
                          onBlur: formik?.handleBlur,
                        }}
                        className={"py-0 "}
                        fullwidth={true}
                        error={
                          formik.touched.street && Boolean(formik.errors.street)
                        }
                        errorMessage={
                          formik.touched.street && formik.errors.street
                        }
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-3 md:ml-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      City
                    </div>
                    <div className="md:ml-8 col-span-2">
                      <FormInput
                        dom={{
                          type: "text",
                          name: "city",
                          className: "p-2.5",
                          value: formik?.values?.city,
                          onChange: formik?.handleChange,
                          onBlur: formik?.handleBlur,
                        }}
                        className={"py-0 "}
                        fullwidth={true}
                        error={
                          formik.touched.city && Boolean(formik.errors.city)
                        }
                        errorMessage={formik.touched.city && formik.errors.city}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 md:rounded-b-lg md:py-3">
                  <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      State
                    </div>
                    <div className="md:ml-8 col-span-2">
                      <FormInput
                        dom={{
                          type: "text",
                          name: "state",
                          className: "p-2.5",
                          value: formik?.values?.state,
                          onChange: formik?.handleChange,
                          onBlur: formik?.handleBlur,
                        }}
                        className={"py-0 "}
                        fullwidth={true}
                        error={
                          formik.touched.street && Boolean(formik.errors.state)
                        }
                        errorMessage={
                          formik.touched.state && formik.errors.state
                        }
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-3 md:ml-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      PostalCode
                    </div>
                    <div className="md:ml-8 col-span-2">
                      <FormInput
                        dom={{
                          type: "text",
                          name: "postalCode",
                          className: "p-2.5",
                          value: formik?.values?.postalCode,
                          onChange: formik?.handleChange,
                          onBlur: formik?.handleBlur,
                        }}
                        className={"py-0 "}
                        fullwidth={true}
                        error={
                          formik.touched.postalCode &&
                          Boolean(formik.errors.postalCode)
                        }
                        errorMessage={
                          formik.touched.postalCode && formik.errors.postalCode
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 md:rounded-b-lg md:py-3">
                  <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Country
                    </div>
                    <div className="md:ml-8 col-span-2">
                      <FormInput
                        dom={{
                          type: "text",
                          name: "country",
                          className: "p-2.5",
                          value: formik?.values?.country,
                          onChange: formik?.handleChange,
                          onBlur: formik?.handleBlur,
                        }}
                        className={"py-0 "}
                        fullwidth={true}
                        error={
                          formik.touched.country &&
                          Boolean(formik.errors.country)
                        }
                        errorMessage={
                          formik.touched.country && formik.errors.country
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="title font-semibold text-base	md:rounded-lg py-3.5 px-4">
                Additional Information
              </div>
              <div className="grid md:rounded-b-lg md:py-6 pt-2 px-4">
                <div className="grid md:grid-cols-12 md:rounded-b-lg">
                  <div className="fieldName font-normal md:col-span-2 text-sm flex items-start md:mb-0 mb-2">
                    Description
                  </div>
                  <div className="md:ml-7 md:col-span-10">
                    <FormTextarea
                      dom={{
                        type: "text",
                        name: "description",
                        className: "p-2.5 ",
                        value: formik?.values?.description,
                        onChange: formik?.handleChange,
                        onBlur: formik?.handleBlur,
                        rows: 6,
                      }}
                      fullwidth={true}
                      error={
                        formik.touched.description &&
                        Boolean(formik.errors.description)
                      }
                      errorMessage={
                        formik.touched.description && formik.errors.description
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-end md:py-4 md:m-0 m-3 md:px-0 px-4 md:static fixed bottom-0 right-0 z-20">
            <button
              type="button"
              className="btn btn-primary-outlined bg-white-100 mx-1.5 capitalize"
              onClick={() => navigate("/fmi-leads")}
              disabled={isLoader}
            >
              Cancel
            </button>
            <Button
              type="submit"
              className="btn btn-primary disabled:!bg-red-900 md:w-10 !w-fit ml-1.5 capitalize"
              disabled={isLoader}
              loader={isLoader}
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FmiLeadsCreate;
